import React, {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useState,
} from 'react';

import { Diary } from '../../../../type/recipe';

const DiaryShortsContext = createContext<{
  diary: Diary;
  showComments: boolean;
  setShowComments: Dispatch<SetStateAction<boolean>>;
  getDiaryPhotoId: (diaryId: number, index: number) => string;
  diaryPhotoIndexMap: Map<number, number>;
  setDiaryPhotoIndexMap: Dispatch<SetStateAction<Map<number, number>>>;
} | null>(null);

export const useDiaryShortsContext = () => {
  const context = useContext(DiaryShortsContext);

  if (!context)
    throw new Error(
      'useDiaryShortsContext should be used within DiaryShortsContext.Provider',
    );

  return context;
};

const _DiaryShortsRoot = ({
  children,
  diary,
}: {
  children: ReactNode;
  diary: Diary;
}) => {
  const [showComments, setShowComments] = useState(false);

  /**
   * diary.id를 key로 갖고, diary.photo의 index를 value로 갖는 Map
   */
  const [diaryPhotoIndexMap, setDiaryPhotoIndexMap] = useState(
    new Map<number, number>(),
  );

  const getDiaryPhotoId = (diaryId: number, index: number) =>
    `diary-${diaryId}-${index}`;

  return (
    <DiaryShortsContext.Provider
      value={{
        diary,
        showComments,
        setShowComments,
        getDiaryPhotoId,
        diaryPhotoIndexMap,
        setDiaryPhotoIndexMap,
      }}
    >
      {children}
    </DiaryShortsContext.Provider>
  );
};

export default _DiaryShortsRoot;
